import { get } from 'lodash';
import { Service, ServicesMap } from '@zapier/services/esm/types';

type ObjectWithSelectedApi = {
  selected_api: string | null | undefined;
};

export default function getAssociatedService(
  obj: ObjectWithSelectedApi | null | undefined,
  services: ServicesMap
): Service | null | undefined {
  if (!obj || !services || !obj.selected_api) {
    return null;
  }

  return get(services, obj.selected_api, null);
}
